<template>
    <div class="form-group">
        <label :for="'input_'+block.id" v-text="label"></label>
        <input type="text" class="form-control" :value="block.text" @input="fireInput" ref="input" :id="'input_'+block.id">
    </div>
</template>
<script>
export default {
  props: ["label", "value"],
  data() {
    return {
      block: this.value
    };
  },
  methods: {
    save() {
      let form = new FormData();
      form.set("edit_text_part[translation_text]", this.block.text);
      form.set("edit_text_part[submit]", null);
      store.commit("addSavingProcess");
      return axios
        .post(
          "/api/" +
            store.state.language +
            "/content/" +
            this.block.id +
            "/edit_text_part",
          form
        )
        .then(({ data }) => {
          store.commit("finishSavingProcess");
          return data.result;
        });
    },
    fireInput($event) {
      this.block.text = $event.target.value;
      this.$emit("input", this.block);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Parts/Input/Text.vue